module.exports = __webpack_public_path__ + "img/163.cellular.a1c3d346.svg";